import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "rounded-lg" }
const _hoisted_2 = ["disabled"]

import { boolean } from "yup";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonTag',
  props: {
		icon: {
			type: String,
			default: "/media/icons/login-icon.svg",
		},
		label: {
			type: String,
			default: "No hint",
		},
		styleLabel: {
			type: String,
			default: "No hint",
		},
		css: {
			type: String,
			default:
				"bg-secondary border-secondary text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none ",
		},
		iconStyle: {
			type: String,
			default: "w-6 h-6",
		},
		type: {
			type: String,
			default: "",
		},
		textLoading: {
			type: String,
			default: "Patienter svp...",
		},
		loader: {
			type: Boolean,
			default: false,
		},
		activeIcon: {
			type: Boolean,
			default: false,
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      disabled: __props.loader,
      class: _normalizeClass([
				__props.css,
				{
					'items-center space-x-4 flex flex-row justify-center rounded-lg': true,
					'cursor-pointer': !__props.loader,
					'cursor-not-allowed opacity-75': __props.loader,
				},
			])
    }, [
      (!__props.loader && __props.activeIcon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([__props.iconStyle, { 'bg-no-repeat bg-cover': true }]),
            style: _normalizeStyle({ backgroundImage: 'url(' + __props.icon + ')' })
          }, null, 6))
        : _createCommentVNode("", true),
      (__props.loader)
        ? (_openBlock(), _createBlock(_component_Spinner, {
            key: 1,
            width_: "10px",
            height_: "30px",
            width: "1px",
            height: "15px"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(__props.styleLabel)
      }, _toDisplayString(__props.loader ? __props.textLoading : __props.label), 3)
    ], 10, _hoisted_2)
  ]))
}
}

})